import React from "react"
import SignIn from "../components/SignIn"

const SignInScreen = (props) => {
  return <SignIn {...props}/>
}
export default SignInScreen
